import { BaseService } from "core/services";
import { PivotRouteService } from "application/pivot/services";

class PivotService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new PivotRouteService());
	}
}

export default PivotService;